import { Component, OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { HeaderService } from 'src/app/shared/services/header/header.service';

import { DocumentModel } from '../../../shared/models/document.model';
import { ErrorModel } from '../../../shared/models/error.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

@Component({
  selector: 'app-identification-summary',
  templateUrl: './identification-summary.component.html',
  styleUrls: ['./identification-summary.component.scss'],
})
export class IdentificationSummaryComponent implements OnInit {
  errorInfo = new ErrorModel();
  documentInfo: DocumentModel;
  /**
   * Summary Configuration with services pand providers
   * @param abreCuentasNavigationService
   * @param analytics
   * @param abreCuentasService
   */
  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private bioCatchService: BioCatchService,
    private headerService: HeaderService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(false, false, false);
  }

  /**
   * Summary Initialize
   */
  ngOnInit() {
    this.initBioCatch();
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
  }
  /**
   * Summary Continue with the next Step
   */
  next() {
    console.log('identification - NextStep()');
    // this.bitacoraService.saveDataInBitacora('store-document-listener-ms');
    const bitacoraEvent = 'fingersPrintScan_succes';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.navigationService.nextStep();
  }

  initBioCatch() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
  }
}
